(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var badges = document.querySelectorAll('.fits-badge');
    if (!badges.length) return;

    var stored = localStorage.getItem('fiberwerx-vehicle');
    var vehicle = null;
    try { vehicle = stored ? JSON.parse(stored) : null; } catch (e) { vehicle = null; }

    if (!vehicle || !vehicle.slug) return;

    var slug = 'fitment:' + vehicle.slug;

    badges.forEach(function (badge) {
      var tags = badge.getAttribute('data-fitment-tags') || '';
      if (tags.split(',').indexOf(slug) !== -1) {
        badge.style.display = 'inline-flex';
      }
    });
  });
})();
